import { useTranslation } from 'react-i18next';

export const useLang = () => {
  const { t } = useTranslation();
  return (text: string, variable?: { [key: string]: unknown }) => {
    return t(text, variable);
  };
};
